module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title-section"
  }, [_c('span', [_vm._v(_vm._s(_vm.product_name))]), _vm._v(" "), (_vm.srp_price) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.srp_price))]) : _vm._e(), _vm._v(" "), (_vm.shop_name) ? _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.shop_name) + " ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e8f68d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductAttribute/productDetail.vue
// module id = 1233
// module chunks = 2